import React from 'react';
import SlideNavigation from './SlideNavigation';
import CoverSlide from './slides/CoverSlide';
import OverviewSlide from './slides/OverviewSlide';
import CategorySlide from './slides/CategorySlide';
import IdeaSlide from './slides/IdeaSlide';
import MatrixSlide from './slides/MatrixSlide';
import QuickWinsSlide from './slides/QuickWinsSlide';
import SummarySlide from './slides/SummarySlide';

export default function PresentationContainer({
    slides,
    currentSlide,
    onPrev,
    onNext,
    onGoTo,
    onExit,
    isFirst,
    isLast,
    totalSlides,
    // Data props
    ideas,
    ideasByCategory,
    quickWins,
    mappingName
}) {
    const renderSlide = (slide) => {
        switch (slide.type) {
            case 'cover':
                return (
                    <CoverSlide
                        mappingName={mappingName}
                        totalIdeas={slide.data.totalIdeas}
                    />
                );

            case 'overview':
                return (
                    <OverviewSlide
                        sectionNumber={slide.sectionNumber}
                        ideas={ideas}
                        ideasByCategory={ideasByCategory}
                    />
                );

            case 'category':
                return (
                    <CategorySlide
                        sectionNumber={slide.sectionNumber}
                        category={slide.data.category}
                        ideas={slide.data.ideas}
                    />
                );

            case 'idea':
                return (
                    <IdeaSlide
                        sectionNumber={slide.sectionNumber}
                        idea={slide.data.idea}
                        ideaIndex={slide.data.ideaIndex}
                        totalIdeasInCategory={slide.data.totalIdeasInCategory}
                    />
                );

            case 'matrix':
                return (
                    <MatrixSlide
                        sectionNumber={slide.sectionNumber}
                        ideas={ideas}
                    />
                );

            case 'quickWins':
                return (
                    <QuickWinsSlide
                        sectionNumber={slide.sectionNumber}
                        ideas={quickWins}
                    />
                );

            case 'summary':
                return (
                    <SummarySlide
                        ideas={ideas}
                        ideasByCategory={ideasByCategory}
                        quickWins={quickWins}
                    />
                );

            default:
                return null;
        }
    };

    const currentSlideData = slides[currentSlide];

    return (
        <div className="fixed inset-0 bg-black z-50 overflow-hidden">
            {/* Slide Content */}
            <div className="h-full w-full pb-16">
                <div
                    key={currentSlide}
                    className="h-full w-full animate-fadeIn"
                    style={{
                        animation: 'fadeIn 0.3s ease-in-out'
                    }}
                >
                    {currentSlideData && renderSlide(currentSlideData)}
                </div>
            </div>

            {/* Navigation */}
            <SlideNavigation
                currentSlide={currentSlide}
                totalSlides={totalSlides}
                onPrev={onPrev}
                onNext={onNext}
                onGoTo={onGoTo}
                onExit={onExit}
                isFirst={isFirst}
                isLast={isLast}
            />

            {/* Global Styles */}
            <style>{`
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateX(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }
            `}</style>
        </div>
    );
}
